module.exports = __webpack_public_path__ + "static/media/microUSB.fb624060.png";